import React, {Component} from 'react';
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {navigationAdded} from "../actions/OptionsActionsV2";
import Loader from "@amzn/meridian/loader";
import ErrorPage from "./utils/ErrorPage";
import Table from "@amzn/meridian/table";
import TableRow from "@amzn/meridian/table/table-row";
import TableCell from "@amzn/meridian/table/table-cell";
import Tooltip from "@amzn/meridian/tooltip"
import Column from "@amzn/meridian/column";
import {
    chainWalk, formQueryParams, getFilteredLocations,
    getOrDefaultValueForCell, getTotalUnopenedBags, getTotalBagCount, getTotalSortLocationsFromNodeResourceData, missingBagforStowV2
} from "../Utility";
import {FormattedMessage, injectIntl} from "react-intl";
import {PackageStatus} from "../enums";
import {getTableCellCount, getTableCellHeader} from "./utils/TableCellUtil";
import RefreshTimer from "./RefreshTimer";
import {FEATURES} from "../constants";
import Link from "@amzn/meridian/link";

class ClusterV3 extends Component {

    constructor(props) {
        super(props);
        this.state = {
            sortColumn: "cluster",
            sortDirection: "ascending"
        }
    }


    render() {
        const {
            loading, error, stowPackageMetricsMap, minOfWorkMetricsMap, inductPackageMetricsMap, stowAssociateMetricsMap, nodeResourceData, stowBinMetricsMapForStowV2
        } = this.props;
        this.aggregateStowRate = 0;
        this.aggregateLFM = 0;
        if (error) {
            return <ErrorPage errorId="stow.error" errorMessage="Some error occurred"/>
        }
        const allClusters = [
            ...Object.keys(stowPackageMetricsMap),
            ...Object.keys(minOfWorkMetricsMap),
            ...Object.keys(inductPackageMetricsMap),
            ...Object.keys(stowAssociateMetricsMap),
            ...Object.keys(stowBinMetricsMapForStowV2),
        ];

        const distinctClusters = [...new Set(allClusters)];

        if (loading && !distinctClusters.length) {
            return (
                <Column
                    height="400px"
                    alignmentHorizontal="center"
                >
                    <Loader/>
                </Column>
            );
        }
        let filteredClusters = getFilteredLocations(distinctClusters, stowPackageMetricsMap, this.isDRSStowVisibilityEnabled());
        filteredClusters = filteredClusters.filter(cluster => cluster !== ("totalMinOfWork"));

        filteredClusters = [...filteredClusters, ...Object.keys(nodeResourceData)];
        filteredClusters = [...new Set(filteredClusters)];

        const onSort = (sortDetails) => {
            this.setState({
                sortColumn: sortDetails.sortColumn,
                sortDirection: sortDetails.sortDirection
            })
        }

        const sortColumn = this.state.sortColumn;
        const direction = this.state.sortDirection;
        filteredClusters.sort((c1, c2) => {
            const c1CombinedMetricsMap = this.getCombinedMetricsMap(c1);
            const c2CombinedMetricsMap = this.getCombinedMetricsMap(c2);
            if (c1CombinedMetricsMap[sortColumn] < c2CombinedMetricsMap[sortColumn]) {
                return direction === "ascending" ? -1 : 1
            }
            if (c1CombinedMetricsMap[sortColumn] > c2CombinedMetricsMap[sortColumn]) {
                return direction === "ascending" ? 1 : -1
            }
            return 0
        });

        return (
            <Column>
                <RefreshTimer deps={[stowPackageMetricsMap]} />
                <div style={{ overflowX: "auto", maxWidth: "100%" }}>
                    <Table headerRows={2} showDividers={false} showStripes={false} spacing="small" fixHeaderRows={true}
                           fixHeaderRowsFullWidth={true}
                           sortColumn={this.state.sortColumn}
                           sortDirection={this.state.sortDirection}
                           onSort={onSort}
                           data-cy={"clusterTable"}>
                        {this.renderHeadings()}
                        {this.renderSubHeadings()}
                        {filteredClusters.map((cluster) => this.renderClusterRow(cluster))}
                        {filteredClusters.length ? this.renderTotalClusterRow() : null}
                    </Table>
                </div>
            </Column>
        )
    }

    renderHeadings() {
        return (
            <TableRow>
                <TableCell/>
                <TableCell>
                    <FormattedMessage id="cluster.packages" defaultMessage="Packages"/>
                </TableCell>
                <TableCell/>
                <TableCell/>
                <TableCell/>
                <TableCell/>
                <TableCell/>
                {this.isADTAVisibilityEnabled() && <TableCell/>}
                {this.isADTAVisibilityEnabled() && <TableCell/>}
                {this.isZancaSortVisibilityEnabled() && <TableCell/>}
                <TableCell/>
                {this.isZancaSortVisibilityEnabled() && <TableCell/>}
                <TableCell>
                    <FormattedMessage id="cluster.performance" defaultMessage="Performance"/>
                </TableCell>
                <TableCell/>
                <TableCell/>
                <TableCell>
                    <FormattedMessage id="cluster.stowers" defaultMessage="Stowers"/>
                </TableCell>
            </TableRow>
        )
    }

    renderSubHeadings() {
        return (
            <TableRow>
                <TableCell sortColumn="cluster">
                    <FormattedMessage id="cluster.cluster" defaultMessage="Cluster"/>
                </TableCell>
                <TableCell sortColumn="plannedPackages" alignmentHorizontal="right">
                    <Tooltip position={"top"} title={this.props.intl.formatMessage({id: "tooltip.cluster.container_planned"})}>
                        <FormattedMessage id="cluster.container_planned" defaultMessage="C. Planned"/>
                    </Tooltip>
                </TableCell>
                <TableCell sortColumn="receivedPackages" alignmentHorizontal="right">
                    <Tooltip position={"top"} title={this.props.intl.formatMessage({id: "tooltip.cluster.arrived"})}>
                        <FormattedMessage id="cluster.arrived" defaultMessage="Arrived"/>
                    </Tooltip>
                </TableCell>
                <TableCell sortColumn="currentInductedPackages" alignmentHorizontal="right">
                    <FormattedMessage id="cluster.inducted" defaultMessage="Inducted"/>
                </TableCell>
                {this.isADTAVisibilityEnabled() && getTableCellHeader("currentStowBufferedPackages")}
                <TableCell sortColumn="stowedPackages" alignmentHorizontal="right">
                    <FormattedMessage id="cluster.stowed" defaultMessage="Stowed"/>
                </TableCell>
                <TableCell sortColumn="stowVsPlan" alignmentHorizontal="right">
                    <Tooltip position={"top"} title={this.props.intl.formatMessage({id: "tooltip.cluster.stow_plan"})}>
                        <FormattedMessage id="cluster.stow_plan" defaultMessage="Stow/Plan"/>
                    </Tooltip>
                </TableCell>
                <TableCell sortColumn="problemSolvePackages" alignmentHorizontal="right">
                    <Tooltip position={"top"} title={this.props.intl.formatMessage({id: "tooltip.cluster.ps"})}>
                        <FormattedMessage id="cluster.ps" defaultMessage="PS"/>
                    </Tooltip>
                </TableCell>
                {this.isADTAVisibilityEnabled() && getTableCellHeader("currentMFRJackpotBufferedPackages")}
                {this.isCartVisibilityEnabled() &&
                    <TableCell sortColumn="carts" alignmentHorizontal="right">
                        <FormattedMessage id="cluster.cartsMissing" defaultMessage="Unopened Carts"/>
                    </TableCell>
                }
                {this.isZancaSortVisibilityEnabled() &&
                    <TableCell sortColumn="openedBags" alignmentHorizontal="right">
                        <FormattedMessage id="cluster.open_bags" defaultMessage="Open Bags"/>
                    </TableCell>
                }
                <TableCell sortColumn="binsMissingBag" alignmentHorizontal="right">
                    <FormattedMessage id="cluster.missing" defaultMessage="Unopened Bags"/>
                </TableCell>
                {this.isZancaSortVisibilityEnabled() &&
                    <TableCell sortColumn="totalSortLocations" alignmentHorizontal="right">
                        <FormattedMessage id="cluster.totalSortLocations" defaultMessage="Total Sort Locations"/>
                    </TableCell>
                }
                <TableCell sortColumn="minutesOfWork" alignmentHorizontal="right">
                    <Tooltip position="top" title={this.props.intl.formatMessage({id: "tooltip.cluster.minutes_of_work"})}>
                        <FormattedMessage id="cluster.minutes_of_work" defaultMessage="Min of Work"/>
                    </Tooltip>
                </TableCell>
                <TableCell sortColumn="stowRate" alignmentHorizontal="right">
                    <Tooltip position={"top"} title={this.props.intl.formatMessage({id: "tooltip.cluster.stow_rate"})}>
                        <FormattedMessage id="cluster.stow_rate" defaultMessage="Stow rate"/>
                    </Tooltip>
                </TableCell>
                <TableCell sortColumn="scanCompliance" alignmentHorizontal="right">
                    <Tooltip position={"top"} title={this.props.intl.formatMessage({id: "tooltip.cluster.scan_compliance"})}>
                        <FormattedMessage id="cluster.scan_compliance" defaultMessage="Scan comp."/>
                    </Tooltip>
                </TableCell>
                <TableCell sortColumn="activeStowers" alignmentHorizontal="right">
                    <Tooltip position={"top"} title={this.props.intl.formatMessage({id: "tooltip.cluster.active"})}>
                        <FormattedMessage id="cluster.active" defaultMessage="Active"/>
                    </Tooltip>
                </TableCell>
            </TableRow>
        )
    }

    renderClusterRow(cluster) {
        const combinedMetricsMap = this.getCombinedMetricsMap(cluster);
        this.aggregateStowRate += ((combinedMetricsMap.stowRate === "-") ? 0 : combinedMetricsMap.stowRate);
        this.aggregateLFM += ((combinedMetricsMap.lastFifteenMinuteStowRate === "-") ? 0 : combinedMetricsMap.lastFifteenMinuteStowRate);

        const stowBufferedCell =
            this.getADTATableCell(combinedMetricsMap.currentStowBufferedPackages, cluster, PackageStatus.CURRENT_STOW_BUFFERED)
        const mfrJackpotBufferedCell =
            this.getADTATableCell(combinedMetricsMap.currentMFRJackpotBufferedPackages, cluster, PackageStatus.CURRENT_MFR_JACKPOT_BUFFERED)
        return (
            <TableRow highlightOnHover={true} key={cluster} onClick={() => this.clusterRowClicked(cluster)} data-cy={"clusterDataRow"}>
                <TableCell>{cluster}</TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.plannedPackages}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {this.renderPackageCount(combinedMetricsMap.receivedPackages, cluster, PackageStatus.CURRENT_RECEIVED)}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {this.renderPackageCount(combinedMetricsMap.currentInductedPackages, cluster, PackageStatus.CURRENT_INDUCTED)}
                </TableCell>
                {stowBufferedCell}
                <TableCell alignmentHorizontal="right">
                    {this.renderPackageCount(combinedMetricsMap.stowedPackages, cluster, PackageStatus.STOWED)}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.stowVsPlan}%
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {this.renderPackageCount(combinedMetricsMap.problemSolvePackages, cluster, PackageStatus.PROBLEM_SOLVE)}
                </TableCell>
                {mfrJackpotBufferedCell}
                {
                    this.isCartVisibilityEnabled()
                        &&
                    <TableCell alignmentHorizontal="right">
                        {combinedMetricsMap.unopenedCarts}
                    </TableCell>
                }
                {this.isZancaSortVisibilityEnabled() &&
                    <TableCell alignmentHorizontal="right">
                        {combinedMetricsMap.openedBags}
                    </TableCell>
                }
                <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.binsMissingBag}
                </TableCell>
                {this.isZancaSortVisibilityEnabled() &&
                    <TableCell alignmentHorizontal="right">
                        {combinedMetricsMap.totalSortLocations}
                    </TableCell>
                }
                <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.minutesOfWork}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {isFinite(parseFloat(combinedMetricsMap.stowRate/combinedMetricsMap.activeStowers).toFixed(2))  ? parseFloat(combinedMetricsMap.stowRate/combinedMetricsMap.activeStowers).toFixed(2):"-"}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.scanCompliance}%
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.activeStowers}
                </TableCell>
            </TableRow>
        )
    }

    renderTotalClusterRow() {
        const {
            totalStowPackageMetrics, totalInductPackageMetrics, totalStowAssociateMetrics, stowBinMetricsMapForStowV2,
            nodeResourceDataMap, totalStowCartMetricsMap, stowBagMetricsMap
        } = this.props;
        if (!this.aggregateStowRate || !totalStowAssociateMetrics["Total"] || !totalStowAssociateMetrics["Total"].activeStowers || totalStowAssociateMetrics["Total"].activeStowers === "-") {
            totalStowPackageMetrics["Total"] = {
                ...totalStowPackageMetrics["Total"],
                stowRate: "-"
            }
        } else {
            totalStowPackageMetrics["Total"] = {
                ...totalStowPackageMetrics["Total"],
                stowRate: parseFloat( this.aggregateStowRate / totalStowAssociateMetrics["Total"].activeStowers).toFixed(2)
            }
        }
        if (!this.aggregateLFM || !totalStowPackageMetrics["Total"] || !totalStowPackageMetrics["Total"].currentInductedPackages || totalStowPackageMetrics["Total"].currentInductedPackages === "-"){
            totalStowPackageMetrics["Total"] = {
                ...totalStowPackageMetrics["Total"],
                minutesOfWork: "-"
            }
        } else {
            totalStowPackageMetrics["Total"] = {
                ...totalStowPackageMetrics["Total"],
                minutesOfWork: parseFloat((totalStowPackageMetrics["Total"].currentInductedPackages / this.aggregateLFM) * 60).toFixed(1)
            }
        }
        return (
            <TableRow data-cy={"clusterTotalRow"}>
                <TableCell>Total</TableCell>
                <TableCell alignmentHorizontal="right">
                    {getOrDefaultValueForCell(totalStowPackageMetrics, "Total", "plannedPackages")}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {this.renderTotalPackageCount(getOrDefaultValueForCell(totalInductPackageMetrics, "Total", "receivedPackages"),
                        PackageStatus.CURRENT_RECEIVED)}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {this.renderTotalPackageCount(getOrDefaultValueForCell(totalStowPackageMetrics, "Total", "currentInductedPackages"),
                        PackageStatus.CURRENT_INDUCTED)}
                </TableCell>
                {this.renderStowBufferedTotalCount()}
                <TableCell alignmentHorizontal="right">
                    {getOrDefaultValueForCell(totalStowPackageMetrics, "Total", "stowedPackages")}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {getOrDefaultValueForCell(totalStowPackageMetrics, "Total", "stowVsPlan")}%
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {this.renderTotalPackageCount(getOrDefaultValueForCell(totalStowPackageMetrics, "Total", "problemSolvePackages"),
                        PackageStatus.PROBLEM_SOLVE)}
                </TableCell>
                {this.renderMFRJackpotBufferedTotalCount()}
                {
                    this.isCartVisibilityEnabled()
                    &&
                    <TableCell alignmentHorizontal="right">
                        {getOrDefaultValueForCell(totalStowCartMetricsMap, "Total", "cartsMissing")}
                    </TableCell>
                }
                {this.isZancaSortVisibilityEnabled() &&
                    <TableCell alignmentHorizontal="right">
                        {getTotalBagCount(stowBagMetricsMap, "openBags")}
                    </TableCell>
                }
                <TableCell alignmentHorizontal="right">
                    {getTotalUnopenedBags(nodeResourceDataMap, stowBinMetricsMapForStowV2)}
                </TableCell>
                {this.isZancaSortVisibilityEnabled() &&
                    <TableCell alignmentHorizontal="right">
                        {getTotalSortLocationsFromNodeResourceData(nodeResourceDataMap)}
                    </TableCell>
                }
                <TableCell alignmentHorizontal="right">
                    {getOrDefaultValueForCell(totalStowPackageMetrics, "Total", "minutesOfWork")}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {getOrDefaultValueForCell(totalStowPackageMetrics, "Total", "stowRate")}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {getOrDefaultValueForCell(totalStowPackageMetrics, "Total", "scanCompliance")}%
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {getOrDefaultValueForCell(totalStowAssociateMetrics, "Total", "activeStowers")}
                </TableCell>
            </TableRow>
        )
    }

    renderStowBufferedTotalCount() {
        if (this.isADTAVisibilityEnabled()) {
            return <TableCell alignmentHorizontal="right">
                {this.renderTotalPackageCount(
                    getOrDefaultValueForCell(this.props.totalStowPackageMetrics, "Total", "currentStowBufferedPackages"))}
            </TableCell>
        }
    }

    renderMFRJackpotBufferedTotalCount() {
        if (this.isADTAVisibilityEnabled()) {
            return <TableCell alignmentHorizontal="right">
                {this.renderTotalPackageCount(getOrDefaultValueForCell(this.props.totalStowPackageMetrics, "Total", "currentMFRJackpotBufferedPackages"))}
            </TableCell>
        }
    }

    getCombinedMetricsMap = cluster => {
        const {
            stowPackageMetricsMap, minOfWorkMetricsMap, inductPackageMetricsMap, stowAssociateMetricsMap, stowBinMetricsMapForStowV2,
            nodeResourceDataMap, stowCartMetricsMap, stowBagMetricsMap
        } = this.props;
        const defaultMetricValue = "-"
        return {
            cluster: cluster,
            unopenedCarts: getOrDefaultValueForCell(stowCartMetricsMap, cluster, "missingCarts"),
            binsMissingBag: missingBagforStowV2(nodeResourceDataMap, stowBinMetricsMapForStowV2, cluster),
            totalSortLocations: chainWalk(() => nodeResourceDataMap.get(cluster), defaultMetricValue),
            openedBags: chainWalk(() => stowBagMetricsMap[cluster].openBags, defaultMetricValue),
            plannedPackages: chainWalk(() => stowPackageMetricsMap[cluster].plannedPackages, defaultMetricValue),
            receivedPackages: chainWalk(() => inductPackageMetricsMap[cluster].receivedPackages, defaultMetricValue),
            currentInductedPackages: chainWalk(() => stowPackageMetricsMap[cluster].currentInductedPackages, defaultMetricValue),
            stowedPackages: chainWalk(() => stowPackageMetricsMap[cluster].stowedPackages, defaultMetricValue),
            stowVsPlan: chainWalk(() => stowPackageMetricsMap[cluster].stowVsPlan, defaultMetricValue),
            problemSolvePackages: chainWalk(() => stowPackageMetricsMap[cluster].problemSolvePackages, defaultMetricValue),
            minutesOfWork: chainWalk(() => isNaN(parseFloat(minOfWorkMetricsMap[cluster].minutesOfWork).toFixed(1))? defaultMetricValue:parseFloat(minOfWorkMetricsMap[cluster].minutesOfWork).toFixed(1), defaultMetricValue),
            stowRate: chainWalk(() => stowPackageMetricsMap[cluster].stowRate, defaultMetricValue),
            lastFifteenMinuteStowRate: chainWalk(() => minOfWorkMetricsMap[cluster].lastFifteenMinuteStowRate, defaultMetricValue),
            scanCompliance: chainWalk(() => stowPackageMetricsMap[cluster].scanCompliance, defaultMetricValue),
            currentStowBufferedPackages: chainWalk(() => stowPackageMetricsMap[cluster].currentStowBufferedPackages, defaultMetricValue),
            currentMFRJackpotBufferedPackages: chainWalk(() => stowPackageMetricsMap[cluster].currentMFRJackpotBufferedPackages, defaultMetricValue),
            activeStowers: chainWalk(() => stowAssociateMetricsMap[cluster].activeStowers, defaultMetricValue),
        }
    }

    clusterRowClicked = clickedCluster => {
        this.props.dispatch(navigationAdded({
            key: 'Cluster',
            value: clickedCluster
        }))
    }

    renderTotalPackageCount = (value, state) => {
        const params = {
            PACKAGE_STATUS: state
        }
        return value !== 0 && value !== '-' ?
            <Link href={this.getPackageListURL(params)}
                  type="secondary"> {value} </Link> : value
    }

    getADTATableCell = (value, aisle, state) => {
        return this.isADTAVisibilityEnabled() && getTableCellCount(this.renderPackageCount(value, aisle, state))
    }

    renderPackageCount = (value, cluster, state) => {
        const params = {
            PACKAGE_STATUS: state,
            CLUSTER: cluster
        }
        return value !== 0 && value !== '-' ?
            <Link href={this.getPackageListURL(params)}
                  type="secondary"> {value} </Link> : value
    }

    getPackageListURL = (params) => {
        const options = this.props.options
        if (options.cycle) {
            params["CYCLE"] = options.cycle;
        }
        return "#packageList/?" + formQueryParams(params);
    }

    isADTAVisibilityEnabled = () => {
        return this.props.featureStatus && this.props.featureStatus[FEATURES.ADTA_VISIBILITY];
    }

    isDRSStowVisibilityEnabled = () => {
        return this.props.featureStatus && this.props.featureStatus[FEATURES.DRS_STOW_VISIBILITY];
    }

    isCartVisibilityEnabled = () => {
        return this.props.featureStatus && this.props.featureStatus[FEATURES.CART_VISIBILITY];
    }

    isZancaSortVisibilityEnabled = () => {
        return this.props.featureStatus && this.props.featureStatus[FEATURES.IS_ZANCASORT_VISIBILITY_ENABLED];
    }
}

const mapStateToProps = state => ({
    loading: state.clusterReducerV2.loading,
    error: state.clusterReducerV2.error,
    options: state.optionsReducer.options,
    minOfWorkMetricsMap: state.clusterReducerV2.minOfWorkMetricsMap,
    stowPackageMetricsMap: state.clusterReducerV2.stowPackageMetricsMap,
    stowBinMetricsMapForStowV2:state.clusterReducerV2.stowBinMetricsMapForStowV2,
    stowBagMetricsMap: state.clusterReducerV2.stowBagMetricsMap,
    inductPackageMetricsMap: state.clusterReducerV2.inductPackageMetricsMap,
    stowAssociateMetricsMap: state.clusterReducerV2.stowAssociateMetricsMap,
    totalStowPackageMetrics: state.clusterReducerV2.totalStowPackageMetrics,
    totalStowBinMetrics: state.clusterReducerV2.totalStowBinMetrics,
    totalInductPackageMetrics: state.clusterReducerV2.totalInductPackageMetrics,
    totalStowAssociateMetrics: state.clusterReducerV2.totalStowAssociateMetrics,
    nodeResourceData: state.clusterReducerV2.nodeResourceData,
    nodeResourceDataMap : state.clusterReducerV2.nodeResourceDataMap,
    featureStatus: state.configReducer.featureStatus
});
export default injectIntl(withRouter(connect(mapStateToProps)(ClusterV3)));


// WEBPACK FOOTER //
// ./src/components/ClusterV3.js